import { useRef } from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import { Box, Typography } from '@mui/material';

export default function RHFFileField({ name, required = false, fileType, label = 'Click here to upload.' }) {
  const { control, formState } = useFormContext();
  const { errors } = formState;
  const inputRef = useRef(null);

  const validateFileType = (file) => {
    if (!fileType) {
      return true; 
    }

    if (Array.isArray(fileType)) {
      return fileType.some((type) => file.name.endsWith(type));
    }

    return file.name.endsWith(fileType);
  };

  const resetInput = () => {
    if (inputRef.current) {
      inputRef.current.value = null;
    }
  };

  const getErrorMessage = () => {
    const fieldErrors = name.split('.').reduce((acc, key) => acc[key] || {}, errors);
    return fieldErrors.message;
  };

  return (
    <Controller
      name={name}
      control={control}
      rules={{
        required: required ? 'This field is required.' : false,
        validate: (files) => {
          if (files && files.length > 0 && !validateFileType(files[0])) {
            return `Invalid file type. Allowed file types are: ${fileType}`;
          }
          return true;
        },
      }}
      render={({ field }) => (
        <Box
          onClick={() => {
            resetInput();
            inputRef.current.click();
          }}
          width={1}
          sx={{
            py: 2,
            px: 2,
            border: getErrorMessage() ? '1px dashed red' : '1px dashed #ccc',
            cursor: 'pointer',
          }}
        >
          <Typography variant="body1" fontWeight={500}>
            {label}
          </Typography>
          {field.value && field.value[0] && (
            <Typography
              sx={{
                textOverflow: 'ellipsis',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                mt: 1,
              }}
            >
              {field.value[0].name}
            </Typography>
          )}
          {getErrorMessage() && (
            <Typography variant="caption" color="error">
              {getErrorMessage()}
            </Typography>
          )}
          <input
            onChange={(e) => {
              field.onChange(e.target.files);
            }}
            type="file"
            ref={inputRef}
            hidden
          />
        </Box>
      )}
    />
  );
}
